import {accessControlEnvironmentKey} from "@/environments.js";

export function accessControlHeaders() {
  return {
    "API-Key": accessControlEnvironmentKey,
    "Content-Type": "application/json"
  };
}
